import axios from 'axios'
import { getHeader } from '../../helpers/utility'

const authGetRequest = async (url, payload) => {
  return await axios.get(url, { headers: getHeader() })
}

export default authGetRequest
